import SectionSelectionButton from "./SectionSelectionButton";
import SectionSelectionPulldown from "./SectionSelectionPulldown"

const SectionSelectionClassNames = (partId) => {
  const baseClassNames = "my-0.5 sm:py-0.5 mx-0 sm:mx-0 cursor-pointer hover:text-main-blue hover:font-bold hover:underline"
  if (partId === "P05") {
    return baseClassNames + " h-12"
  } else {
    return baseClassNames + " h-10"
  }
}

function SectionSelection({ section, textAboveTheSection, isActive, selectedState, onSelect = f => f }) {
  return (
    <div
      className={SectionSelectionClassNames(selectedState.partId)}
      key={section.name.toString()}
    >
      {
        section.hasOwnProperty("elements")
        ?
        <SectionSelectionPulldown
          section={section}
          textAboveTheSection={textAboveTheSection}
          isActive={isActive}
          selectedState={selectedState}
          onSelect={onSelect}
          key={section.name.toString()}
        />
        :
        <SectionSelectionButton
          section={section}
          textAboveTheSection={textAboveTheSection}
          isActive={isActive}
          onSelect={onSelect}
          key={section.name.toString()}
        />
      }
    </div>
  )
}

export default SectionSelection;
